import { render, staticRenderFns } from "./ic-calendar.vue?vue&type=template&id=15fc619d&"
import script from "./ic-calendar.vue?vue&type=script&lang=js&"
export * from "./ic-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('15fc619d', component.options)
    } else {
      api.reload('15fc619d', component.options)
    }
    module.hot.accept("./ic-calendar.vue?vue&type=template&id=15fc619d&", function () {
      api.rerender('15fc619d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/svg/ic-calendar.vue"
export default component.exports